<template>
  <div id="app">
    <!-- <m-top></m-top> -->
    <m-header></m-header>
    <!-- 导航-->
    <!-- 子路由的出口 -->
   <keep-alive>
   <!-- 这里是会被缓存的视图组件 -->
   <!-- :key='$route.fullPath'解决同一组件复用，不跳转页面 -->
    <router-view v-if="$route.meta.keepAlive" :key='$route.fullPath'></router-view>
    </keep-alive>
    <!-- 这里是不被缓存的视图组件 -->
     <router-view v-if="!$route.meta.keepAlive" :key='$route.fullPath'></router-view>
     <nav-footer></nav-footer>
  </div>
</template>

<script>
 // import MTop from '@/common/MTop'
import MHeader from '@/common/MHeader'
import NavFooter from '@/common/NavFooter'
export default {
  components:{
    MHeader,
    NavFooter,
    //MTop
  },
	data() {
		return{

		}
	},
  mounted() {
 // window.scrollTo(0,0);
  },
 created(){


	},
	methods:{

	}

}
</script>

<style lang="scss" scoped>
	
	
</style>
